




import React from 'react'
import './ NewsCoverage.css'



const  NewsCoverage:React.FC = () => {


  return (
   <>
   <div className='w-screen overflow-hidden min-h-screen p-10 custom-news-coverage-container '>
    <div className='flex flex-col items-center justify-center mx-auto max-w-[800px]'>
        <div className=' sm:text-lg md:text-xl lg:text-3xl xl:text-4xl font-sans'><h3>Press Releases & News Coverage</h3></div>
        <div className=' text-center font-sans w-[80%] p-10'><p>At Next Play Nation, we’re proud to share the milestones,
             partnerships, and stories that shape our mission. Our Press Releases & News Coverage section is coming soon 
             and will highlight the impactful work being done within our organization and the communities we serve.
              From event announcements to media features, this space will keep you informed about how we’re advancing athlete development, 
              life skills,  and community empowerment across the nation. Stay connected and see how we’re making headlines both on and off the field.</p></div>



    </div>
   </div>
   
   
   
   
   
   
   </>
  )
}

export default  NewsCoverage
